





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { FrontpageViewModel } from '@/types/contentServerContract';
import CallToAction from '@/project/form/CallToAction.vue';
import { isDevMode } from '@/core/environmentService';
import appStore from '@/core/app/app.store';

@Component({
    components: { CallToAction }
})
export default class FrontPage extends Vue {
    @Prop() content!: FrontpageViewModel;

    private isDevMode(): boolean {
        return isDevMode();
    }

    mounted() {
        appStore.hideMobileSearch = true;
        appStore.isFrontPage = true;
    }

    beforeDestroy() {
        appStore.hideMobileSearch = false;
        appStore.isFrontPage = false;
    }
}
